import { HeartHandshake, Target, Telescope } from "lucide-react";
import React, { useEffect } from "react";

const MissionVision = () => {

 useEffect(() => {
  import("aos").then((AOS) => {
    AOS.default.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  });
}, []);

  return (
    <section className="py-10 bg-gradient-to-b lg:px-8 from-[#0b1120] to-[#1a1f35] text-white">
      <div className="container mx-auto px-4 text-center">

        <h2
          className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold mb-6"
          data-aos="fade-down"
        >
          Our{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
            Mission & Vision
          </span>
        </h2>

        {/* 🚀 NATURAL HUMAN-WRITTEN INTRO FOR SEO */}
        <p
          className="sm:text-lg text-[16px] text-gray-300 max-w-4xl mx-auto mb-12 leading-relaxed"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          At <span className="text-blue-400 font-semibold">Game Zone Hub</span>, we want to bring the joy of gaming back to basics. We noticed that playing a simple game online was becoming too complicated, with forced downloads, sign-ups, and hidden costs. Our goal is to fix that. We are building a space where you can just show up, pick a great <strong>HTML5 browser game</strong>, and start having fun immediately in a safe, secure environment.
        </p>

        <ul className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-8 mt-10">

          <li data-aos="zoom-in"  data-aos-delay="200" className="h-full group">
            <div className="bg-[#1e293b] h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-white/5 hover:border-blue-500/50" >
              <Target className="text-blue-400 w-14 h-14 mx-auto mb-6 group-hover:rotate-12 transition-transform" />
              <h3 className="text-xl font-bold mb-3 text-white">Our Mission</h3>
              <p className="text-gray-400 text-sm leading-6">
                We are on a mission to make gaming easy and accessible. You shouldn't need an expensive PC or the latest smartphone to enjoy a good game. We want to provide a massive library of <strong>free online games</strong> that run smoothly on whatever device you already own, without asking for your credit card or email address.
              </p>
            </div>
          </li>
          

          <li data-aos="zoom-in" data-aos-delay="300" className="h-full group">
             <div className="bg-[#1e293b] h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-white/5 hover:border-yellow-500/50">
                <Telescope className="text-yellow-400 w-14 h-14 mx-auto mb-6 group-hover:-rotate-12 transition-transform" />
                <h3 className="text-xl font-bold mb-3 text-white">Our Vision</h3>
                <p className="text-gray-400 text-sm leading-6">
                  We envision Game Zone Hub as the internet's favorite digital playground. We want to be the first place you think of when you have a 10-minute break and want to relax. By supporting talented indie developers and focusing on what players actually want, we are building a gaming community that lasts.
                </p>
             </div>
          </li>

          <li data-aos="zoom-in" data-aos-delay="400" className="h-full group">
             <div className="bg-[#1e293b] h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-white/5 hover:border-purple-500/50">
                <HeartHandshake className="text-purple-400 w-14 h-14 mx-auto mb-6 group-hover:scale-110 transition-transform"/>
                <h3 className="text-xl font-bold mb-3 text-white">Our Values</h3>
                <p className="text-gray-400 text-sm leading-6">
                   Your safety and time are our top priorities. We refuse to host broken games or annoying pop-up ads. We believe in keeping our platform clean, virus-free, and family-friendly, so players of any age can explore and play with total peace of mind.
                </p>
             </div>
          </li>

        </ul>
      </div>
    </section>
  );
};

export default MissionVision;